import { createAction } from '@wix/communities-blog-client-common';
import { normalizePost } from '../services/post-utils';
import { getCategoryIds } from '../selectors/categories-selectors';
import { debug } from '../services/debug';

export const PUBLISH_POST_REQUEST = 'post/PUBLISH_REQUEST';
export const PUBLISH_POST_SUCCESS = 'post/PUBLISH_SUCCESS';
export const PUBLISH_POST_FAILURE = 'post/PUBLISH_FAILURE';

export const publishPostRequest = createAction(PUBLISH_POST_REQUEST);
export const publishPostSuccess = createAction(PUBLISH_POST_SUCCESS);
export const publishPostFailure = createAction(PUBLISH_POST_FAILURE);

export const publishPost = (postId) => (dispatch, getState, { request }) => {
  dispatch(publishPostRequest());

  const promise = request.post(`/_api/posts/${postId}/publish`, {});

  return promise
    .then((post) => dispatch(publishPostSuccess(normalizePost({ post, blogCategoryIds: getCategoryIds(getState()) }))))
    .catch((error) => {
      debug.error(error);
      return dispatch(publishPostFailure(error));
    })
    .then(() => promise);
};
